import { Route } from '@angular/router'

export const AdminRoutes: Route[] = [
    {
        path: '',
        loadComponent: () =>
            import('./page-admin-home/page-admin-home.component').then(
                (c) => c.PageAdminHomeComponent,
            ),
    },
    {
        path: 'users',
        loadComponent: () =>
            import('./page-admin-users/page-admin-users.component').then(
                (c) => c.PageAdminUsersComponent,
            ),
    },
    {
        path: 'users/:id',
        loadComponent: () =>
            import('./page-admin-user-details/page-admin-user-details.component').then(
                (c) => c.PageAdminUserDetailsComponent,
            ),
    },
    {
        path: 'benefits',
        loadComponent: () =>
            import('./page-admin-benefits/page-admin-benefits.component').then(
                (c) => c.PageAdminBenefitsComponent,
            ),
    },
    {
        path: 'vendors',
        loadComponent: () =>
            import('./page-admin-vendors/page-admin-vendors.component').then(
                (c) => c.PageAdminVendorsComponent,
            ),
    },
    {
        path: 'vendors/:id',
        loadComponent: () =>
            import('./page-admin-vendor-details/page-admin-vendor-details.component').then(
                (c) => c.PageAdminVendorDetailsComponent,
            ),
    },
    {
        path: 'clients',
        loadComponent: () =>
            import('./page-admin-clients/page-admin-clients.component').then(
                (c) => c.PageAdminClientsComponent,
            ),
    },
    {
        path: 'clients/:id',
        loadComponent: () =>
            import('./page-admin-client-details/page-admin-client-details.component').then(
                (c) => c.PageAdminClientDetailsComponent,
            ),
    },
    {
        path: 'categories',
        loadComponent: () =>
            import('./page-admin-categories/page-admin-categories.component').then(
                (c) => c.PageAdminCategoriesComponent,
            ),
    },
    {
        path: 'raffles',
        loadComponent: () =>
            import('./page-admin-raffles/page-admin-raffles.component').then(
                (c) => c.PageAdminRafflesComponent,
            ),
        data: { pageTitle: 'Raffles' },
    },
    {
        path: 'landing-page',
        loadComponent: () =>
            import('./page-admin-landing-page/page-admin-landing-page.component').then(
                (c) => c.PageAdminLandingPageComponent,
            ),
        data: { pageTitle: 'Landing Page' },
    },
]
